import { render, staticRenderFns } from "./TableTemplateForm.vue?vue&type=template&id=12c234f0&"
import script from "./TableTemplateForm.vue?vue&type=script&lang=js&"
export * from "./TableTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports